export default __webpack_public_path__ + "static/media/Freebooter's Helm of the Roaring Jungle.317cef6d.jpg";